"use strict";

module.exports = function (config) {
  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/continuous/index.js
// module id = 2241
// module chunks = 0